export const noop = (terminal) => terminal;
//# sourceMappingURL=noop.js.map